import { createSlice } from "@reduxjs/toolkit";
import { getEnrollmentAgreementDetailsAPI } from "../../services/getEnrollmentAgreementDetails";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const getEnrollmentAgreementDetailsSlice = createSlice({
  name: "getEnrollmentAgreementDetails",
  initialState,
  reducers: {
    getEnrollmentAgreementDetailsInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
      state.statusCode = undefined;
    },
    getEnrollmentAgreementDetailsInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = "";
      state.message = "";
      state.statusCode = undefined;
    },
    getEnrollmentAgreementDetailsInfoFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = "";
      state.error = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    getEnrollmentAgreementDetailsInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const getEnrollmentAgreementDetailsHandler =
  (payload, options = {}) =>
  async (dispatch) => {
    const requestOptions = { skipForbiddenRedirect: true, ...options };

    try {
      dispatch(
        getEnrollmentAgreementDetailsAction.getEnrollmentAgreementDetailsInfo(
          payload,
        ),
      );
      const response = await getEnrollmentAgreementDetailsAPI(
        payload,
        requestOptions,
      );
      dispatch(
        getEnrollmentAgreementDetailsAction.getEnrollmentAgreementDetailsInfoSuccess(
          response,
        ),
      );
    } catch (e) {
      const failurePayload =
        e && typeof e === "object" && "message" in e
          ? e
          : { message: e || "Something went wrong." };
      dispatch(
        getEnrollmentAgreementDetailsAction.getEnrollmentAgreementDetailsInfoFailure(
          failurePayload,
        ),
      );
    }
  };

export default getEnrollmentAgreementDetailsSlice.reducer;
export const getEnrollmentAgreementDetailsAction =
  getEnrollmentAgreementDetailsSlice.actions;
